export default {
  data() {
    return {
      loading: 0,
    };
  },
  computed: {
    isLoading() {
      return !this.isLoaded;
    },
    isLoaded() {
      return this.loading === 0;
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/Progress.js